import { Injectable } from '@angular/core';
import { UsersService } from 'gung-standard';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloUserServiceService extends UsersService {

  public findUsers() : Observable<UserResponse[]> {
    const url = `json/tylo/find-users`;
    return this.http.get<UserResponse[]>(url);
  }
  
}

interface UserResponse {
  id: string;
  name: string;
  email: string;
}